import { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * Renders `value` as a scannable QR PNG (data URL, generated client-side —
 * the address never leaves the browser to produce this). Colors use the
 * existing ink/paper tokens rather than plain black/white so it stays on
 * brand while keeping the strong contrast QR scanners need.
 */
export function QrCode({ value, size = 176 }: { value: string; size?: number }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(null);
    QRCode.toDataURL(value, {
      width: size,
      margin: 0,
      color: { dark: "#0D1117", light: "#EDEFF2" },
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  return (
    <div className="inline-flex bg-paper p-3 rounded-lg" style={{ width: size + 24, height: size + 24 }}>
      {dataUrl ? (
        <img src={dataUrl} alt="Bitcoin payment address QR code" width={size} height={size} />
      ) : (
        <div style={{ width: size, height: size }} className="bg-ink-800/20 animate-pulse" aria-hidden="true" />
      )}
    </div>
  );
}
